<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Title -->
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Sistema</span>
        <h3 class="page-title">Configurações</h3>
      </d-col>
    </d-row>

    <d-row>
      <d-col md="12">
        <d-card>
          <d-tabs card ref="tabs">
            <d-tab title="Dados da empresa" active class="p-3">
              <company-form/>
            </d-tab>
            <d-tab title="Textos dos impressos" class="p-3">
              <messages-form/>
            </d-tab>
            <d-tab title="Variáveis do sistema" class="p-3">
              <settings-form/>
            </d-tab>
            <d-tab title="Resultados" class="p-3">
              <result-form/>
            </d-tab>
            <d-tab title="Classificação de risco" class="p-3">
              <risk-classification-form/>
            </d-tab>
            <d-tab title="Validação da medição" class="p-3">
              <validation-form/>
            </d-tab>
            <d-tab title="Controle de acesso" class="p-3" v-if="isAdmin">
              <access-control-form/>
            </d-tab>
          </d-tabs>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CompanyForm from '_modules/settings/components/CompanyForm.vue';
import MessagesForm from '_modules/settings/components/MessagesForm.vue';
import SettingsForm from '_modules/settings/components/SettingsForm.vue';
import AccessControlForm from '_modules/settings/components/AccessControlForm.vue';
import ResultForm from '_modules/settings/components/ResultForm.vue';
import ValidationForm from '_modules/settings/components/ValidationForm.vue';
import RiskClassificationForm from '../components/RiskClassificationForm.vue';
import {
  _LOAD_MODEL_COMPANY_,
  _LOAD_MODEL_MESSAGE_,
  _LOAD_MODEL_SETTING_,
  _LOAD_MODEL_RESULTS_,
  COMPANY,
  MESSAGES,
  SETTINGS,
  RESULTS,
  MEASUREMENT_VALIDATION,
  _LOAD_MODEL_VALIDATION_,
  RISK_CLASSIFICATIONS,
  _LOAD_MODEL_RISK_CLASSIFICATIONS_,
} from '../components/SettingsModel';

export default {
  name: 'setting-profile',
  components: {
    CompanyForm,
    MessagesForm,
    SettingsForm,
    AccessControlForm,
    ResultForm,
    ValidationForm,
    RiskClassificationForm,
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getSettings',
      'checkAdmin',
    ]),
    company() {
      const { company } = this.$store.state.settings;
      if (company) {
        Events.$emit(_LOAD_MODEL_COMPANY_, company);
        return company;
      }
      return COMPANY;
    },
    getSettingsSystem() {
      this.setToggle({ type: 'progress', bool: true });
      this.getSettings()
        .then(() => {
          this.loadSettings();
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    loadSettings() {
      this.company();
      this.messages();
      this.settings();
      this.results();
      this.riskClassifications();
      this.validation();
    },
    messages() {
      const { messages } = this.$store.state.settings;
      if (messages) {
        Events.$emit(_LOAD_MODEL_MESSAGE_, messages);
        return messages;
      }
      return MESSAGES;
    },
    settings() {
      const { settings } = this.$store.state.settings;
      if (settings) {
        Events.$emit(_LOAD_MODEL_SETTING_, settings);
        return settings;
      }
      return SETTINGS;
    },
    results() {
      const { results } = this.$store.state.settings;
      if (results) {
        Events.$emit(_LOAD_MODEL_RESULTS_, results);
        return results;
      }
      return RESULTS;
    },
    riskClassifications() {
      const { riskClassifications } = this.$store.state.settings;
      if (riskClassifications) {
        Events.$emit(_LOAD_MODEL_RISK_CLASSIFICATIONS_, riskClassifications);
        return riskClassifications;
      }
      return RISK_CLASSIFICATIONS;
    },
    validation() {
      const { validation } = this.$store.state.settings;
      if (validation) {
        Events.$emit(_LOAD_MODEL_VALIDATION_, validation);
        return validation;
      }
      return MEASUREMENT_VALIDATION;
    },
  },
  mounted() {
    this.checkAdmin()
      .then(() => this.$refs.tabs.updateTabs());
    this.getSettingsSystem();
  },
};
</script>

<style lang="scss">
.tabs {
  .card-header { background: rgba(0, 0, 0, 0.03); }
}
</style>
